import { render, staticRenderFns } from "./ScholarshipCadetshipCMS.vue?vue&type=template&id=66e2e3fc&scoped=true"
import script from "./ScholarshipCadetshipCMS.vue?vue&type=script&lang=js"
export * from "./ScholarshipCadetshipCMS.vue?vue&type=script&lang=js"
import style0 from "./ScholarshipCadetshipCMS.vue?vue&type=style&index=0&id=66e2e3fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e2e3fc",
  null
  
)

export default component.exports